export const NavProductTitle = {
  bindings: {
    title: '<',
    firstName: '<',
    lastName: '<',
  },

  template: `
    <div class="nav-product-title">
      <div class="d-flex flex-column align-items-md-end text-white">
        <span ng-bind="$ctrl.title"></span>
        <small ng-if="$ctrl.firstName" class="d-none d-md-inline">
          by {{ $ctrl.firstName }}
          <span ng-if="$ctrl.firstName !== 'Voome'">
            {{ $ctrl.lastName }}
          </span>
        </small>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavProductTitle.js